angular.module('impactx.catalog').service('CheckoutCatalogActions', [
    'dataGen',
    '$mdDialog',
    '$q',
    'ToastService',
    'TranslationService',
    CheckoutCatalogActions]);

function CheckoutCatalogActions(dataGen, $mdDialog, $q, ToastService, TranslationService) {
    var self = this;

    self.denyAll = function (event, productIds) {
        var tempScopeOuter = {};
        var formData = {
            proIds: productIds
        };
        return dataGen.postAsForm(tempScopeOuter, formData, "/product/checkout/denywarning").then(function () {
            if (tempScopeOuter.data.referencingProducts.length > 0) {
                return $mdDialog.show({
                    controller: "DenyWarningCtrl",
                    controllerAs: "denyWarningCtrl",
                    templateUrl: "modules/catalog/templates/deny-warning.tmpl.html",
                    parent: angular.element(document.body),
                    targetEvent: event,
                    clickOutsideToClose: false,
                    locals: {
                        trns: tempScopeOuter.trns,
                        referencingProducts: tempScopeOuter.data.referencingProducts
                    }
                }).then(function () {
                    return denyAllFinal(formData);
                }, function () {
                    return "closed";
                });
            }
            else {
                return denyAllFinal(formData);
            }
        });
    };

    function denyAllFinal(formData) {
        return dataGen.postAsForm({}, formData, "/product/checkout/denyall").then(function () {
            ToastService.openStandardToast(TranslationService.get('deleteSuccess'));
        });
    }

    return {
        denyAll: self.denyAll
    };
}